<template>
	<div style="display: flex;">
		<TToolTip v-if="url" :width="240">
			<t-timpex-icon
				slot="target"
				style="padding-right:10px;"
				icon="signature"
				type="bp"
				color="blue"
			/>
			<div style="box-sizing: border-box; padding: 10px 20px; overflow:hidden; display:flex; align-items:center; justify-content: center;">
				<img style="height:200px;" :src="url">
			</div>
		</TToolTip>
		<div>{{ name }}</div>
	</div>
</template>

<script>
export default {
	name: 'Signature',
	props: {
		url: String,
		name: String,
	}
};
</script>

<style lang="scss" scoped>

</style>
